import { Component, OnInit } from '@angular/core';
import { SharedService } from './core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  /** App shell title. */
  title = 'Glamera Registration';
  /** True after first successful user-interaction audio unlock. */
  private audioUnlocked = false;

  constructor(public sharedService: SharedService) {}

  ngOnInit(): void {
    if (!localStorage.getItem('lang')) {
      localStorage.setItem('lang', 'ar');
    }
    const lang = localStorage.getItem('lang') || 'ar';
    const dir = lang === 'en' ? 'ltr' : 'rtl';
    localStorage.setItem('dir', dir);
    document.documentElement.setAttribute('dir', dir);
    document.body.setAttribute('dir', dir);

    this.disableDevTools();
    this.unlockAudioOnFirstInteraction();
  }

  /** Registers a one-time interaction listener to satisfy browser autoplay policy for future sounds. */
  private unlockAudioOnFirstInteraction(): void {
    const unlockAudio = () => {
      if (this.audioUnlocked) return;

      const audio = new Audio();
      audio.play().then(() => {
        this.audioUnlocked = true;
      }).catch(() => {});
    };

    document.addEventListener('click', unlockAudio, { once: true });
  }

  /** Prevents opening DevTools and right-click context menu. */
  disableDevTools(): void {
    // document.addEventListener('contextmenu', (e) => e.preventDefault());
    // document.addEventListener('keydown', (e) => {
    //   const key = e.key.toUpperCase();
    //   if (key === 'F12') e.preventDefault();
    //   if (['META', 'ALT', 'DEAD', '∆'].includes(key)) e.preventDefault();
    // });
  }
}
